import type { SalonStockerHttpTypes } from "@repo/api-sdk";

const ROOT_QUERY_KEY = "products" as const;
export const queryKeys = {
  // ...queryKeysFactory(ROOT_QUERY_KEY),

  featuredProducts: (
    options?: SalonStockerHttpTypes.StoreFeaturedProductsParams
  ) => [ROOT_QUERY_KEY, "featured", options] as const,

  saleProducts: (options?: SalonStockerHttpTypes.StoreProductSaleListParams) =>
    [ROOT_QUERY_KEY, "sale", options] as const,

  /**
   * Every cached pricing response, whatever its product set. The prices in
   * them are per salon (trade prices for claimed sellers), so a claim or a
   * release makes all of them stale.
   */
  productsPricingAll: () => [ROOT_QUERY_KEY, "pricing"] as const,

  productsPricing: (product_ids: string[]) =>
    [ROOT_QUERY_KEY, "pricing", product_ids] as const
};
